import { type FC } from "react";
import { useShopfrontDispatch, useShopfrontSelector } from "../../../_Bootstrap/hooks";
import { LAYOUT_USER_MENU_TOGGLE } from "../../../Actions/General/LayoutActions";
import UserImg from "../../../Common/User/UserImg";
import { fireEventType } from "../../../Utilities/Generic/ActionsHelper";

export const UserInfo: FC = () => {
    const dispatch = useShopfrontDispatch();

    const id = useShopfrontSelector(state => state.user.id);
    const name = useShopfrontSelector(state => state.user.id ? state.user.name : "");
    const image = useShopfrontSelector(state => state.user.id ? state.user.image : "");

    const handleClick = (): void => {
        dispatch(fireEventType(LAYOUT_USER_MENU_TOGGLE));
    };

    if(!id) {
        return null;
    }

    return (
        <div
            id="user-information"
            onClick={handleClick}
        >
            <UserImg key={id} url={image} />
            <p>{name}</p>
        </div>
    );
};
